import {ArticleView} from 'epic-minimalist-blog/app/scripts';
import React from 'react';

export default function ArticleWrapper(props) {
    return (
        <div className="blog-wrapper">
            <ArticleView {...props} />
        </div>
    );
}
